export * from './post-zahlungseingang.component';
export * from './post-zahlungseingang.component.module';